import { FC, Fragment } from "react";
import { QuestionnaireContextProvider } from "./QuestionnaireContext";
import { UnitsContextProvider } from "./UnitsContext";
import { CompaniesContextProvider } from "./CompaniesContext";


/**
 * List of contexts used in the app
 * @warning be warned as the order matters,  if one context depends on another , make sure you place the most significant one first
 * */
const contexts = [
    QuestionnaireContextProvider,
    UnitsContextProvider,
    CompaniesContextProvider
];


const Items: FC<{ item: FC[] }> = ({ item, children }) => {
    if (!item || item.length === 0) {
        return <Fragment>
            {children}
        </Fragment>
    }

    // Item will be the last element of the `contexts` array
    // be warned as this will actually remove the item from the array
    const Item = item.shift()!;
    return <Item>
        <Items item={item}>
            {children}
        </Items>
    </Item>
}


const ContextProvider: FC = ({ children }) => {
    return <Items item={contexts}>
        {children}
    </Items>
}

export default ContextProvider;